import { render } from "./newPassword.vue?vue&type=template&id=2d10778a&scoped=true"
import script from "./newPassword.vue?vue&type=script&lang=js"
export * from "./newPassword.vue?vue&type=script&lang=js"

import "./newPassword.vue?vue&type=style&index=0&id=2d10778a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d10778a"]])

export default __exports__